import React, { PureComponent } from "react";
import { message, Menu, Collapse, Tag, Button, Modal, Icon, Input, Dropdown, Spin} from "antd";
import _ from 'lodash'
import { reactLocalStorage } from 'reactjs-localstorage';
import Docxtemplater from 'docxtemplater';
import JSZip from 'jszip'
import JSZipUtils from 'jszip-utils';

import config from '../../config'
import nanoid from 'nanoid'
import { checkExistingProject } from '../project/util';

import firebase from 'firebase'
import { store } from './../../store'
import { addProject } from './../../actions/projects'
import { updateProjectAction } from './../../actions/projectAction'

import { convertArrayToObject } from './../../util/index';
import json2xls from 'json2xls'
import atob from 'atob';
import { generateXLSX, generateDOCX } from './../../api/project';
import {saveAs} from 'filesaver.js';

const confirm = Modal.confirm;
const Panel = Collapse.Panel;
const SubMenu = Menu.SubMenu;

const customPanelStyle = {
  background: "#f7f7f7",
  borderRadius: 4,
  border: 0,
  overflow: "hidden"
};

class QuestionPanel extends PureComponent {
  constructor(props){
    super(props)
    this.state = {
      manageOption: 'create',
      inputValue: '',
      selectedName: null,
      currentCSVData: null,
      isExporting: false,
      isPanelHide: false
    }
  }

  componentWillReceiveProps (props){
    console.log('received props: ' + JSON.stringify(props))
    if(props.existingQuestionInfo){
      this.setState({ selectedName: props.existingQuestionInfo.name })
      setTimeout(() => {
        this.getCSVData()
      },0)
    }else{
      this.setState({ selectedName: null})
    }
  }

  onCreateProject = () => {
    let inputName = this.state.inputValue;
    if(inputName !== ''){
      let finalSelected = [];
      let selectedQuestions = reactLocalStorage.getObject('selectedQuestions');
      if(!_.isEmpty(selectedQuestions)) {
        selectedQuestions = (selectedQuestions) ? selectedQuestions.selected: [];
        if(selectedQuestions.length > 0) finalSelected = _.cloneDeep(selectedQuestions)
      }

      /* Add New Project With Selected Questions Into Firebase */
      const projectID = nanoid()
      var questionArr = finalSelected

      if(questionArr.length > 0){
        // var questionArr = [{ id: "asd", surveyID: 'adsqwe' }, { id: "asd2", surveyID: 'adsqwe' }, { id: "asd3", surveyID: 'adsqwe' }, { id: "asd4", surveyID: 'adsqwe' }, { id: "asd5", surveyID: 'adsqwe'}]
        questionArr = convertArrayToObject(questionArr)
      }

      checkExistingProject(inputName).then(({ success, user}) => {
        console.log('success ? user ? ' , success, user)
        console.log('user ? ', user)
        
        if (success) {
          console.log('user: ', user)
          console.log('questionArr: ', questionArr)
          console.log('inputName: ', inputName)
          var projectRef = firebase
                    .database()
                    .ref(config.firebaseProjectsPath)
                    .child(projectID)

          var newData = {
            id: projectID,
            name: inputName,
            userId: (user.uid) ? user.uid: null,
            userEmail: (user.email) ? user.email: null,
            questions: questionArr,
            timestamp: firebase.database.ServerValue.TIMESTAMP
          };

          projectRef.set(newData).then((err) => {
            if(!err){
              store.dispatch(updateProjectAction({ action: 'create' }))
              setTimeout(() => {
                message.success("Project had been created successfully!")
                console.log('newData', newData)
                store.dispatch(addProject(newData)) // Add Project in store
                this.setState({ inputValue: '' })
                this.props.setData([]) // Set Question Panel Data
              },0)
            }else message.error("There was error when created. ", err)
          })
        }
      })
    }else message.error('Project name cannot be empty!')
    
  }

  onRemoveTempProject = () => {
    var confirmPrompt = null;
    function confirmPromise() {
      return new Promise((resolve, reject) => {
        confirmPrompt = confirm({
          title: 'You haven save yet. Are you sure to remove all?',
          onOk(e) {
            resolve(true)
          },
          onCancel() { resolve(null) },
          okText: "Remove",
          cancelText: "Cancel",
          okType: "danger"
        })
      })
    }

    confirmPromise().then((confirmed) => {
      if(confirmed){
        this.props.onRemoveAllSelectedQuestions()
        confirmPrompt.destroy()
      }
    })
  }

  onInputChange = (e) => {
    this.setState({ inputValue: e.target.value })
  }

  handleExportClick = (e) =>{
    const projectID = store.getState().projects.filter(e => e.name === this.state.selectedName)[0].id;
    var firebaseToken = (store.getState().user.firebaseToken) ? store.getState().user.firebaseToken: '';
    if(e.key === 'word') {
      console.log('word is processing...')
      this.setState({ isExporting: true })
      generateDOCX({ projectID: projectID, token: firebaseToken }).then((result) => {
        var downloadLink = result.config.url + '?projectID=' + projectID + '&token=' + firebaseToken;
        window.location.href = downloadLink;
        this.setState({ isExporting: false })
      })
    }

    if(e.key === 'excel') {
      console.log('excel is processing...')
      this.setState({ isExporting: true })
      generateXLSX({ projectID: projectID, token: firebaseToken }).then((result) => {
        var downloadLink = result.config.url + '?projectID=' + projectID + '&token=' + firebaseToken;
        window.location.href = downloadLink;
        this.setState({ isExporting: false })
      })
    }
  }

  getCSVData() {
    console.log('getCSVData: ', this.state.selectedName)
    if(this.state.selectedName){
      var questions = store.getState().projects.filter(e => e.name === this.state.selectedName)[0].questions;
      
      var finalQuestions = _.cloneDeep(_.values(questions))
      console.log('finalQuestions: ' + JSON.stringify(finalQuestions))
      var results = []
      finalQuestions.map((q, ind) => {
        // Columns:
        // id, surveyID, surveyName, questionText, tags, answers #1, answers #1 tags,...
        var tempObj = {
          id: q.id,
          surveyID: q.surveyID,
          surveyName: q.surveyName,
          questionText: q.questionText,
          tags: (q.tags) ? q.tags.join(',') : ''
        };
  
        var tempAns = {};
        if(q.answers){
          var answers = JSON.parse(q.answers);
          for(var i = 0; i < answers.length; i++){
            console.log('answers at i ' + i + " : " + JSON.stringify(answers[i]))
            if(answers[i].answer) tempAns[(i+1) + '_answer'] = answers[i].answer;
            if(answers[i].tags) tempAns[(i+1) + '_tag'] = _.values(answers[i].tags).join(',');
            else tempAns[(i+1) + '_tag'] = '';
          }
        }
        console.log('tempAns ', tempAns)
        results.push(
          _.merge(tempObj, tempAns)
        )
        console.log('... => ', Object.assign({}, tempObj, tempAns ))
  
        if(ind === finalQuestions.length - 1){
          console.log('results: ', results)
          this.setState({ currentCSVData: results })
        }
      })
    }else return null
  }

  saveInputProjectRef = input => this.input = input

  hidePanel = () => {
    const {isPanelHide} = this.state;
    this.setState({
      isPanelHide: !isPanelHide
    })
  }

  render() {
    const { manageOption, inputValue, currentCSVData, selectedName, isExporting, isPanelHide  } = this.state
    const { data = [], onRemove, onQuestionCheck, existingQuestionInfo } =  this.props;
    const hasData = data.length > 0;

    var hasSelectedQuestions = onQuestionCheck.hasSelectedQuestions
    var onNewPanelSelected = onQuestionCheck.onNewPanelSelected

    var existingProjectName = null
    if(onNewPanelSelected === 'false') {
      existingProjectName = existingQuestionInfo.name
    }

    setTimeout(() => {
      this.setState({
        questionData: data
      })  
    },0 )


    const menu = (<Menu>
                    <Menu.Item onClick={(e) => this.setState({ manageOption: 'create' })}>Create New Project</Menu.Item>
                    {/* <SubMenu onClick={(e) => this.setState({ manageOption: 'create' })} title="Update Existing Project">
                    </SubMenu> */}
                  </Menu>)

    
    const exportFile = (<Menu onClick={this.handleExportClick}>
                          <Menu.Item key="excel" >Excel</Menu.Item>
                          <Menu.Item key="word" >Word</Menu.Item>
                        </Menu>)
    


    return (
      <div
        style={{
          display: ((hasData === true && onNewPanelSelected === 'true' ) 
                    || ((typeof existingProjectName) !== 'undefined' && onNewPanelSelected === 'false')) ? "block" : "none",
          position: "fixed",
          bottom: 0,
          width: "100%"
        }}
      >
        <Collapse
          bordered={false}
          onChange={this.hidePanel}
          activeKey={ isPanelHide === false && (hasData || onNewPanelSelected === 'false') ? ["1"] : []}
          defaultActiveKey={ isPanelHide === false && (hasData || onNewPanelSelected === 'false') ? ["1"] : []}
        >
        
          <Panel
            header={ (onNewPanelSelected === 'true' ) ? 'New Project': 'Project ' + existingProjectName }
            key="1"
            style={customPanelStyle}>
            <Spin tip="Hold on! Exporting..." spinning={isExporting}>
              {
                (onNewPanelSelected === 'true') &&
                (
                  <div style={{ textAlign: 'left' }}>
                    <Dropdown overlay={menu}>
                      <a className="ant-dropdown-link" href="#">
                        Create New Project <Icon type="down" />
                      </a>
                    </Dropdown>
                    {
                      (manageOption === 'create') 
                        && (
                        <div style={{ width: '420px' }}>
                          <Input
                            ref="newProjectName"
                            value={inputValue}
                            onChange={this.onInputChange}
                            style={{ display: 'inline-block', width: '200px' }}
                            placeholder="Name new project" />
                          <Button style={{ display: 'inline-block', margin: "10px 15px" }} type="primary" onClick={(e) => this.onCreateProject() }>Create</Button>
                          <Button style={{ display: 'inline-block' }} type="danger" onClick={(e) => this.onRemoveTempProject() }>Delete</Button>
                        </div>
                      )
                    }
                  </div>
                ) 
              }

              {
                (onNewPanelSelected === 'false') &&
                (hasData === true) &&
                (
                  <div style={{ textAlign: 'left' }}>
                    <Dropdown overlay={exportFile}>
                      <a className="ant-dropdown-link" href="#">
                        Export File<Icon type="down" />
                      </a>
                    </Dropdown>
                  </div>
                )
              }

              <ul style={{ textAlign: "left", paddingTop: '20px', paddingBottom: '20px' }}>
                <li style={{ listStyle: 'none' }} >
                  {data.map(o => (
                    <p key={o.id} style={{ marginBottom: 8 }}>
                      <Button
                        style={{ marginRight:8 }}
                        size="small"
                        type="primary"
                        shape="circle"
                        icon="minus"
                        onClick={() => onRemove(o)}
                      />
                      <Tag style={{}} color="blue">{o.questionText}</Tag>
                    </p>
                  ))}
                </li>
                <li style={{ listStyle: 'none' }} >
                  {
                    (data.length === 0) 
                    && (
                      <p>
                        You don't have any question yet. Please add.
                      </p>
                    )
                  }
                </li>
              </ul>
            </Spin>
          </Panel>

        </Collapse>
      </div>
    );
  }
}

export default QuestionPanel;



// WEBPACK FOOTER //
// ./src/components/questionpanel/index.js